export default {
  noDataText: 'aucun transfert en cours',
  noResults: 'aucun transfert trouvé',
  tranfersSelectedCount:
    'Aucun transfert sélectionné | Un transfert sélectionné | {count} transferts sélectionnés ',

  facebookConversation: 'conversation facebook'
}
